/**
 * Detect fn
 */
export default () => 'includes' in String.prototype;
